/*
Sohel 11/16/2022 2700912712 Implemented filter Screen
Suresh Peddavoora 11/22/2022 2700912712 - Fixed Spacing Alignments for Search Reports Button.
 akhila  11/23/2022 2700912712 adding completed styles in stepper.
Prakash  11/23/2022 2700912712 added color for border.
Akhila 11/23/2022 2700912712 Rename button from Search Report to Search Filter Rule
Akhila 11/24/2022 2700912712 implemented animations to completed step
Sai Maheshwar 11/24/2022 2700753823 changed background color for selected step
Sai maheshwar 12/04/2022 2700753823 added unsaved changes alert
lalitha 12/08/2022 2700753823 Renamed Stepper Add Filter Rules
Lalitha 12/09/2022  2700753823 Added reusable backButtonText
Rajesh 12/09/2022 2700753823 toast reset issues
akhila 12/15/2022 2700753823 changed label
Ashraf 15/16/2022 2700753823 fixed role access
akhila 12/20/2022 2700753823 fixed toaster issue in basicInfo
Prakash 12/21/2022 2700753823 Adjusted Padding Alignment.
akhila 12/26/2022 2700753823 changed sourceType in downloadConfigurationUsage
kavyareddy 01/05/2023 2700753823 Fixed downloadConfiguration usage issue
kavyareddy 01/06/2023 2700753823 Fixed download configuration issue
Akhila 01/10/2023 2700753823 Updated the payload in download configuration
Akhila 01/26/2023 2700753823 Back button added unsaved changes popUp alert message
Raghu 02/21/2023 2700753823 changed stepper icons color
Raghu 02/22/2023 2700753823 changed stepper color
Ravi 02//24/2023 2700753823 Added popup in download configuration button
Akhila 03/01/2023 2700753823 Added loader and download toast message for preview File
Ravi 06/09/2023 2700753823 Added Breadcrums in preview
Dilip-pds 11/03/2023  2700753823 Removed unecesarry comment code
Gireesh-pds 12/12/2023  2700753823 changed filter code name
Gireesh-pds 12/12/2023  2700753823 Added printIndividual in  download 
*/
import {Button, makeStyles, Stepper, StepLabel, Step} from '@material-ui/core';
import React, {useRef, useState, useEffect} from 'react';
import reusableInputStyles from '../../../../components/InputStyles';
import Basicinfo from './BasicInfo';
import {ArrowBack} from '@material-ui/icons';
import FieldList from './FieldList';
import SqlRules from './SqlRules';
import {useDispatch, useSelector} from 'react-redux';
import StepConnector from '@material-ui/core/StepConnector';
import {withStyles} from '@material-ui/core/styles';
import useUnsavedChangesWarning from '../../../../util/CustomHooks';
import {setAlertData} from '../../../../redux/reducers/UnsavedChangesAlertReducer';
import {postPrintUsage, resetPrintUsageData} from '../../../../redux/reducers/printUsage';
import {
  printFilterRuleGroup,
  resetFormula,
  resetRuleGroupPrintStatus,
  resetConfigUrl,
  resetDockey,
} from '../../../../redux/reducers/BRE/AddRuleGroup';
import axios from 'axios';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import PageLoader from '../../../../components/PageLoader';
import {backButtonText, downloadButton} from '../../../../util/Content';
import PreviewFileDialog from '../../../../util/PreviewFileDialog';
import {resetDownloadMsg} from '../../../../redux/reducers/PreviewFileData';
import NumberStepIcon from '../../../../components/customStepIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#056c93',
    },
    '& .MuiStepIcon-active': {
      color: '#056c93',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 600,
        fontFamily: 'articulat-cf, sans-serif !important',
      },
    },
  },
}));
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const FilterComponents = ({setValue, rowSelected}) => {
  const stepperClasses = useStyles();
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const steps = ['Basic Info', 'Select Fields', 'Add Filter Rules'];
  // const [selectRows, setSelectRows] = useState();
  const [activeStep, setActiveStep] = React.useState(0);
  const [fieldListCode, setFieldListCode] = useState('');
  const showAlertRef = useRef(false);
  const {routerPrompt, onDirty, onPristine} = useUnsavedChangesWarning();

  // const [reportCodeData, setReportCodeData] = useState("");
  const [fieldList, setFieldList] = useState('');
  const {filterRuleGroupData} = useSelector(({addFilterRuleGroup}) => addFilterRuleGroup);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  const {copySuccessMsg, copyErrorMsg} = useSelector(
    ({addFilterRuleGroup}) => addFilterRuleGroup,
  );
  const {
    successMsg,
    errorMsg,
    isLoading,
    ruleGroupPrintStatus,
    configurationUrl,
    dockey,
  } = useSelector(({addRuleGroup}) => addRuleGroup);
  const [configOpen, setConfigOpen] = useState(false);
  const [isLoadingPrint, setIsLoadingPrint] = useState(false);
  const [configData, setConfigData] = useState(null);
  const printusage = useSelector(({printusage}) => printusage);
  const isCurrentStepCompleted = filterRuleGroupData?.isDraft === 'N';
  const handleDirty = (dirty) => {
    showAlertRef.current = dirty;
    if (dirty) {
      onDirty();
    } else {
      onPristine();
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (showAlertRef.current) {
      dispatch(
        setAlertData({
          showAlert: showAlertRef.current,
          alertCallback: () => {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
          },
        }),
      );
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };
  useEffect(() => {
    if (printusage.errorMsg || printusage.successMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printusage.errorMsg, printusage.successMsg]);
  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingPrint(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingPrint(false);
      }
      readData();
    }
  }, [configurationUrl]);

  useEffect(() => {
    if (ruleGroupPrintStatus && ruleGroupPrintStatus === 200) {
      setTimeout(() => {
        dispatch(resetRuleGroupPrintStatus());
      }, 2000);
    }
  }, [ruleGroupPrintStatus]);

  useEffect(() => {
    return () => {
      dispatch(resetFormula());
    };
  }, []);

  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
    case 0:
      return (
        <Basicinfo
          activeStep={activeStep}
          handleBack={handleBack}
          handleNext={handleNext}
          isCurrentStepCompleted={isCurrentStepCompleted}
          rowSelected={rowSelected}
          {...alertProps}
        />
      );
    case 1:
      return (
        <FieldList
          fieldListCode={fieldListCode}
          setFieldListCode={setFieldListCode}
          handleBack={handleBack}
          handleNext={handleNext}
          fieldList={fieldList}
          rowSelected={rowSelected}
          setFieldList={setFieldList}
          {...alertProps}
        />
      );
    case 2:
      return (
        <SqlRules
          handleBack={handleBack}
          setValue={setValue}
          rowSelected={rowSelected}
          {...alertProps}
        />
      );
    }
  };
  const stepProps = {};
  if (isCurrentStepCompleted) {
    stepProps.nonLinear = true;
  } else {
    stepProps.nonLinear = false;
  }
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Filter Rules'}
        name={'Filter Name'}
        code={filterRuleGroupData?.code}
        description={'Filter Description'}
        descriptionValue={filterRuleGroupData?.description}
      />
      <div className="new-standard-textfields button-table-spacing-mb justify-content-between">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setValue(0);
                  },
                }),
              );
            } else {
              setValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
        {filterRuleGroupData?.code && (
          <div>
            <Button
              type="button"
              variant="outlined"
              className={`mx-1 search-btn ${classes.buttonRoot}`}
              // disabled={usageFilterRuleGroupData?.userMetrix !== "Yes"}
              onClick={(event) => {
                dispatch(
                  postPrintUsage({
                    code: filterRuleGroupData?.code ? filterRuleGroupData.code : '',
                    displayName: filterRuleGroupData?.displayName ?
                      filterRuleGroupData?.displayName :
                      '',
                    description: filterRuleGroupData?.description ?
                      filterRuleGroupData.description :
                      '',
                    returnType: filterRuleGroupData?.returnType ?
                      filterRuleGroupData.returnType :
                      '',
                    sourceType: 'FILTER RULE',
                  }),
                );
              }}
            >
              Download Configuration Usage
            </Button>
            <Button
              type="button"
              variant="outlined"
              className={`mx-1 search-btn`}
              // disabled={Boolean(countTotal === 0)}
              // tooltip: "Print",
              // isFreeAction: true,
              onClick={(event) => {
                dispatch(
                  printFilterRuleGroup({
                    code: filterRuleGroupData?.code ? filterRuleGroupData.code : '',
                    displayName: filterRuleGroupData?.displayName ?
                      filterRuleGroupData?.displayName :
                      '',
                    description: filterRuleGroupData?.description ?
                      filterRuleGroupData.description :
                      '',
                    returnType: filterRuleGroupData?.returnType ?
                      filterRuleGroupData.returnType :
                      '',
                    ruleType: 'FilterRuleGroup',
                    orderBy: '',
                    orderDirection: '',
                    isDraft: filterRuleGroupData?.isDraft?.key ?
                      filterRuleGroupData?.isDraft?.key :
                      '',
                    createdBy: '',
                    createdDate: '',
                    filterRuleGroupId:filterRuleGroupData?.id,
                    printIndividual: 'Y',
                  }),
                );
              }}
            >
              {downloadButton}
            </Button>
          </div>
        )}
      </div>
      {routerPrompt}
      <div className={classes.root} style={{border: '1px solid #cfcfcf'}} >
        <Stepper {...stepProps} activeStep={activeStep} connector={<QontoConnector />}>
          {steps.map((label, index) => (
            <Step
              key={label}
              completed={isCurrentStepCompleted || index < activeStep}
              onClick={() => {
                if (filterRuleGroupData?.isDraft === 'N') {
                  if (showAlertRef.current) {
                    dispatch(
                      setAlertData({
                        showAlert: showAlertRef.current,
                        alertCallback: () => {
                          setActiveStep(index);
                        },
                      }),
                    );
                  } else {
                    setActiveStep(index);
                  }
                }
              }}
              style={{cursor: 'pointer'}}
            >
              <StepLabel
                className={`${stepperClasses.stepperIcon} ${
                  activeStep === index ? 'completedStyle' : null
                }`}
                StepIconComponent={NumberStepIcon}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          <div style={{padding: '1rem 0.5rem'}}>{getStepContent(activeStep)}</div>
        </div>
      </div>
      {(isLoading || printUsageIsLoading || isLoadingPrint) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg || copyErrorMsg) && (
        <ErrorSnackbar
          errorMsg={errorMsg || printUsageErrorMsg || copyErrorMsg || printusage?.errorMsg}
        />
      )}
      {(successMsg || printUsageSuccessMsg || copySuccessMsg) && (
        <SuccessSnackbar
          successMsg={
            successMsg || printUsageSuccessMsg || copySuccessMsg || printusage?.successMsg
          }
        />
      )}
    </>
  );
};

export default FilterComponents;
